// extracted by mini-css-extract-plugin
export default {"itemContainer":"BuildingTabs_itemContainer__CM4D9","itemTitle":"BuildingTabs_itemTitle__nMX-g","itemTitleActive":"BuildingTabs_itemTitleActive__55c3K"};